export default "__VITE_ASSET__Cgc19X14__"